import { TagIcon } from '@mm/icons';
import classnames from 'classnames';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import TagModel from '@mm/state/model/TagModel';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { AccordionItem } from '@mm/components';
import { AssignTagForm } from '../../../AssignTagForm/AssignTagForm';
import { Tag } from '../../../Tag/Tag';
import './chatVariablesTags.pcss';

type PropsFromState = ReturnType<typeof mapStateToProps>;
type PropsFromDispatch = {};

type OuterProps = {
  contactId: number;
  tags: TagModel[];
  isLiveChatContacts?: boolean;
  onChange?: (newTags: TagModel[]) => void;
  collapsedContactView?: boolean;
};

type Props = PropsFromState & PropsFromDispatch & OuterProps;

const ChatVariablesTagsPure = ({
  tags,
  contactId,
  fbPageId,
  onChange,
  isLiveChatContacts = false,
  collapsedContactView,
}: Props) => {
  const onChangeTags = useCallback((newTags: TagModel[]) => {
    onChange && onChange(newTags);
  }, []);

  const tagsWrapperClasses = classnames('contact-tags__wr', {
    'live-chat--contact-tags__wr': isLiveChatContacts,
  });

  if (collapsedContactView) {
    return (
      <div className="live-chat--contact__header--collapsed">
        <TagIcon className="live-chat--contact__header-icon" />
        <span className="live-chat--contact__content-number--collapsed">
          ({tags.length})
        </span>
      </div>
    );
  }

  return (
    <div className={tagsWrapperClasses}>
      <AccordionItem
        icon={<TagIcon className="live-chat--contact__header-icon" />}
        title="Tags"
        count={tags.length}
        closeOnOutsideClick={false}
        openOnMount
      >
        <div className="contact-tags__content">
          <AssignTagForm
            contactId={contactId}
            tags={tags}
            fbPageId={fbPageId}
            onChange={onChangeTags}
          />

          <div className="contact-tags__list">
            {tags.map(tag => (
              <Tag
                key={tag.name}
                item={tag}
                contactId={contactId}
                fbPageId={fbPageId}
                onChange={onChange}
                removable={tag.kind !== 'service'}
              />
            ))}
          </div>
        </div>
      </AccordionItem>
    </div>
  );
};

const mapStateToProps = (state: StoreState) => ({
  fbPageId: activeFacebookPageIdSelector(state),
});

export const ChatVariablesTags = connect<
  PropsFromState,
  PropsFromDispatch,
  OuterProps
>(mapStateToProps)(ChatVariablesTagsPure);
